import React from 'react'

const NavItems = ({text, icon, className, action}) => {
  return (
    <div className={"text-white cursor-pointer py-1 flex items-center px-3 mb-[1px] rounded-lg hover:bg-white/[0.15] " + className}
      onClick={action}  
    >
      <span className='mr-4 text-xl'>{icon}</span>
      {text}
    </div>
  )
}

export default NavItems;  
